import React from 'react';
import { SvgIcon } from '@onsolve/onsolve-ui-components';

const Modality = props => (
    <SvgIcon {...props}>
        <path
            fill="#3777BC"
            stroke="none"
            d="M127.375 98.688h-45a2.811 2.811 0 0 0-2.813 2.815 2.816 2.816 0 0 0 2.813 2.815h45a2.813 2.813 0 0 0 2.813-2.815 2.813 2.813 0 0 0-2.813-2.816ZM127.375 59.313h-45a2.811 2.811 0 0 0-2.813 2.814 2.816 2.816 0 0 0 2.813 2.815h45a2.813 2.813 0 0 0 2.813-2.814 2.818 2.818 0 0 0-2.813-2.816ZM127.375 19.938h-45a2.811 2.811 0 0 0-2.813 2.815 2.816 2.816 0 0 0 2.813 2.814h45a2.813 2.813 0 0 0 2.813-2.814 2.818 2.818 0 0 0-2.813-2.816ZM72.737 20.447 44.612.759a2.812 2.812 0 0 0-4.425 2.304v14.453a44.98 44.98 0 0 0 5.625 89.609h11.25a5.625 5.625 0 0 0 0-11.25h-11.25a33.73 33.73 0 0 1-5.625-66.99v13.552a2.813 2.813 0 0 0 4.425 2.304l28.125-19.688a2.811 2.811 0 0 0 0-4.606Z"
        />
    </SvgIcon>
);

export default Modality;
